import { setAppBusyAction } from '../../reducers/actions/app'
import alertify from 'alertifyjs'

const Firebase = window?.['firebase']

export const database = collection => Firebase.firestore().collection(collection)
export const utcTimestamp = () => Firebase.firestore.FieldValue.serverTimestamp()

/**
 * Read data from Firestore once
 *
 * @param {string} databaseName
 * @return {Observable<any> | Promise<any>}
 */
export const readData = databaseName => (
    database(databaseName)
        .get()
        .then((querySnapshot) => {
            let result = []
            querySnapshot.forEach((doc) => {
                result.push(doc.data())
            })
            return new Promise(resolve => resolve(result))
        })
        .catch(error => console.error("Error getting document:", error))
        .finally(() => setAppBusyAction(false))
)

/**
 * Listen for Firestore data changes and call callback on change
 *
 * @param {string} databaseName
 * @param {Function} callback
 * @return {*}
 */
export const listenData = (databaseName, callback) => (
    database(databaseName)
        .onSnapshot(querySnapshot => {
            let result = []
            querySnapshot.forEach(document => {
                result.push({
                    uid: document.id,
                    ...document.data(),
                })
            })

            callback(result)
        })
)

/**
 * Listen for Firestore data changes and call callback on change
 *
 * @param {string} databaseName
 * @param {Function} callback
 * @return {*}
 */
export const listenDataWithOrderTimestamp = (databaseName, callback) => (
    database(databaseName)
        .orderBy('dateToTimestamp')
        .onSnapshot(querySnapshot => {
            let result = []
            querySnapshot.forEach(document => {
                result.push(document.data())
            })

            callback(result)
        })
)

export const deleteFridgeFood = async (fridgeItemUid, forceAllEaten = false) => {
    const foodFridge = await database('fridge')
        .doc(fridgeItemUid)
        .get()
        .then(response => response.data())

    if ((foodFridge?.countFood ?? 1) > 1 && !forceAllEaten) {
        const newCountFood = foodFridge.countFood - 1
        alertify.set('notifier','position', 'top-left')
        alertify.success(`Počet kusů jídla aktualizováno: ${foodFridge.countFood} > ${newCountFood}`)

        return database('fridge')
            .doc(fridgeItemUid)
            .update({
                countFood: newCountFood,
            })
    }

    alertify.set('notifier','position', 'top-left')
    alertify.success('Jídlo snězeno a odebráno ze seznamu!')
    return database('fridge')
        .doc(fridgeItemUid)
        .delete()
}

export const setCountFood = async (fridgeItemUid, modifier = '-') => {
    const foodFridge = await database('fridge')
        .doc(fridgeItemUid)
        .get()
        .then(response => response.data())

    let newCountFood = foodFridge?.countFood ?? 1

    if (modifier === '-') {
        newCountFood = foodFridge.countFood - 1
    }

    if (modifier === '+') {
        newCountFood = foodFridge.countFood + 1
    }

    alertify.set('notifier','position', 'top-left')
    alertify.success(`Počet kusů jídla aktualizováno: ${foodFridge.countFood} > ${newCountFood}`)

    await database('fridge')
        .doc(fridgeItemUid)
        .update({
            countFood: newCountFood,
        })

    return newCountFood
}
